/* eslint-disable react-refresh/only-export-components */
import * as React from "react"
import * as SheetPrimitive from "@radix-ui/react-dialog"

import { cn } from "@/helpers/classNames"

export const Sheet = SheetPrimitive.Root

export const SheetTrigger = SheetPrimitive.Trigger

export const SheetClose = SheetPrimitive.Close

type SheetContentProps = React.ComponentPropsWithoutRef<
  typeof SheetPrimitive.Content
>

/**
 * Simplified version of shadcn/ui `SheetContent` component
 * intended to display a small panel vertically centered on the screen, sliding in from the left.
 * This is a very specific component (no overlay, no close button inside)
 * used to display the agent metrics panel in the CallPanel view.
 */
export function SidePanelContent({
  children,
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof SheetPrimitive.Content>>
} & SheetContentProps) {
  return (
    <SheetPrimitive.Content
      ref={ref}
      aria-describedby={undefined}
      onInteractOutside={
        (event) =>
          event.preventDefault() /* to keep it open when clicking outside */
      }
      className={cn(
        `
          fixed z-50 transition ease-in-out
          data-[state=closed]:animate-out data-[state=closed]:duration-300
          data-[state=open]:animate-in data-[state=open]:duration-500
        `,
        `
          top-0 left-0 flex h-full items-center
          data-[state=closed]:slide-out-to-left
          data-[state=open]:slide-in-from-left
        `,
        className,
      )}
      {...props}
    >
      <SheetPrimitive.Title className="sr-only">
        Side panel metrics
      </SheetPrimitive.Title>
      <div
        className={cn(
          `
            flex min-h-[200px] items-center rounded-r-xl border-y border-r
            bg-background p-2 shadow-lg
          `,
          className,
        )}
      >
        {children}
      </div>
    </SheetPrimitive.Content>
  )
}
